import React from "react";

interface HighlightedTextProps {
  content: string;
  keyword: string;
}

const HighlightedText = ({
  content,
  keyword,
}: HighlightedTextProps) => {
  if (!keyword) {
    return (
      <span>
        {content}
      </span>
    );
  }
  const parts = content.split(new RegExp(`(${keyword})`, 'gi'));
  return parts.map((part: string, index: number) =>
    part.toLowerCase() === keyword.toLowerCase() ? (
      <span key={index} className="text-orange-500">
        {part}
      </span>
    ) : (
      part
    )
  );
};

export default HighlightedText;
